/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface HomeProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const Home: React.SFC<HomeProps> = ({size, ...props}) => (
  <svg viewBox="0 0 15 15" fill="currentColor" width={ size || "15" } height={ size || "15" } {...props}>
    <path fill="currentColor" d="M8.4 9.6H6v3.6c0 .663-.537 1.2-1.2 1.2H2.4c-.663 0-1.2-.537-1.2-1.2V8.04l-.177.182c-.225.232-.595.238-.827.013-.238-.238-.239-.614-.007-.847L7.2.36l7.025 7.029c.232.232.232.608 0 .84-.232.231-.606.231-.837 0L13.2 8.04v5.16c0 .663-.537 1.2-1.2 1.2H9.601c-.662 0-1.2-.537-1.2-1.2L8.4 9.6zm-6-2.76v6.36h2.4V9.6c0-.663.537-1.2 1.2-1.2h2.4c.663 0 1.2.537 1.2 1.2v3.6H12V6.84l-4.8-4.8-4.8 4.8z"
      fillRule="evenodd" />
  </svg>
);
Home.displayName = 'Home';
export default Home;
/* tslint:enable */
/* eslint-enable */
